/**
 * Shared Shopify constants used by both the setup tutorial (first install)
 * and the scope-update tutorial (re-install when scopes drift).
 */
export { SHOPIFY_SCOPE_LINE as SHOPIFY_REQUIRED_SCOPES } from '../../../../src/lib/shopify/scopes';

const API_BASE = import.meta.env.VITE_API_URL || 'https://api.tagada.io';

export const SHOPIFY_APP_URL = import.meta.env.VITE_SHOPIFY_APP_URL ?? API_BASE;

export const SHOPIFY_REDIRECT_URL =
  import.meta.env.VITE_SHOPIFY_REDIRECT_URL ?? `${API_BASE}/api/public/oauth/shopify/callback`;

export const SHOPIFY_TUTORIAL_ASSET_BASE_PATH =
  import.meta.env.VITE_TUTORIAL_ASSETS_BASE_PATH ?? '/assets/shopify';
